<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text class="d-flex align-center justify-center"><span v-html="text" style="color:#000; font-size:16px!important;word-break:break-word;"></span></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="sb_btn btn-actv" @click="$emit(btn.yes.event, btn.yes.callback)">{{btn.yes.text}}</v-btn>
          <v-btn class="sb_btn btn-dactv" @click="dialog = false" v-if="btn.no.show">{{btn.no.text}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import eventBus from '@/utils/eventBus'
import utils from '@/utils/utils'

export default {
  name: 'ConfirmDialog',
  props: {
    id: {
      type: String
    }
  },
  components: {
  },
  data () {
    return {
      dialog: false,
      title: '',
      text: '',
      btn: {
        yes: {
          text: '',
          event: '',
          callback: {}
        },
        no: {
          text: ''
        }
      }
    }
  },
  mounted () {
    eventBus.$off('CLOSE_CONFIRM_DIALOG'+ this.id)
    eventBus.$on('CLOSE_CONFIRM_DIALOG'+ this.id, () => {
      this.dialog = false
    })

    eventBus.$off('SHOW_CONFIRM_DIALOG'+ this.id)
    eventBus.$on('SHOW_CONFIRM_DIALOG'+ this.id, (options) => {
      this.title = (options.title) ? options.title : ''
      this.text = options.text
      this.btn = {
        yes: {
          text: options.yes.text,
          event: options.yes.event,
          callback: options.yes.callback
        },
        no: {
          show: (options.no.show === false) ? false : true,
          text: options.no.text
        }
      }

      if (utils.isNull(this.btn.yes.text)) {
        this.btn.yes.text = this.$t('common.button.yes')
      }

      if (utils.isNull(this.btn.no.text)) {
        this.btn.no.text = this.$t('common.button.no')
      }

      this.dialog = true
    })
  },
  methods: {
  }
}

</script>
